module.exports = __webpack_public_path__ + "static/media/OBRAS_8.9b488d54.png";